import ProxyBase from '../../../core/proxies/ProxyBase'

class DashboardProxy extends ProxyBase {
  getNewsFeatured(params) {
    return this.get('Dashboard/NewsFeatured', params)
  }
  getNewsAndEvents(params) {
    return this.get('Dashboard/NewsAndEvents', params)
  }
  getReports(params) {
    return this.get('Dashboard/Reports', params)
  }
  getMostPopular(params) {
    return this.get('Dashboard/MostPopular', params)
  }
  getRecentlyViewed(params) {
    return this.get('Dashboard/RecentlyViewed', params)
  }
  getVSIC(params) {
    return this.get('Category/VSIC', params)
  }
  getRiskDistribution(params) {
    return this.get('Dashboard/RiskDistribution', params)
  }
  getSuggestionCompany(params) {
    return this.get('Dashboard/SuggestionCompany', params)
  }
  getSuggestionCompanyDetail(params) {
    return this.get('Dashboard/SuggestionCompanyDetail', params)
  }
  getSavedPortfolio(params) {
    return this.get('Library/SavedPortfolio', params)
  }
  getCreditRiskScore(params) {
    return this.get('Dashboard/CreditRiskScore', params)
  }
  getPerformanceScore(params) {
    return this.get('Dashboard/PerformanceScore', params)
  }
  getTotalAlert(params) {
    return this.get('Dashboard/TotalAlert', params)
  }
  getCurrentPlan(params) {
    return this.get('UserManagement/UserSetting', params)
  }
  getUserPricingPackages() {
    return this.get('UserManagement/UserPricingPackages')
  }
  getTrialList(params) {
    return this.get('Dashboard/TrialList', params)
  }
  checkRequestConnectMap(params) {
    return this.get('ConnectionMap/UpgradeRequests/CheckExists', params)
  }
}

export default new DashboardProxy()
